module.exports = __webpack_public_path__ + "img/home_funeng_bg_operate.41b90939.png";